<template>
  <el-switch
    v-model="isDark"
    :active-action-icon="Moon"
    :inactive-action-icon="Sunny"
    @change="toggleDark"
    style="
      --el-switch-on-color: var(--backgroundCheckColor);
      --el-switch-off-color: var(--backgroundCheckColor);
      --el-switch-border-color: var(--iconColor);
    "
    class="theme-toggle-switch"
  />
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick
} from 'vue';
import { Sunny, Moon } from '@element-plus/icons-vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import { createDark, updateThemeScheme } from '@/utils/js/themeScheme';

import store from '@/store';
// props
const props = defineProps({
  
});
// emit
const emit = defineEmits([
  
]);

const isDark = createDark();

const toggleDark = (flag)=>{
  updateThemeScheme(isDark);
}
// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>
.theme-toggle-switch{
  .el-switch__action{
    .el-icon{
      color: var(--iconColor);
    }
  }
}
</style>

<style lang='less' scoped>
</style>